import { useAuth } from "../contextos/AuthProvider"
const Pie = () => {
    const {user}=useAuth();// eslint-disable-line no-unused-vars 
  
return(
    user !==null ? 
    <footer>
        <div style={{backgroundColor:'#e1e2e3'}}>
        <p style={{marginLeft:'25px', color:'black', fontSize:'10px', clear:'both', backgroundColor:'#e1e2e3'}}>{"Conectado con la cuenta "+ user.email + ". Sistema desarrollado por Cristhian Sancho A. tel 6051-3328. Derechos Rerservados ©"}</p> 
        </div>     
       
    </footer>
    : null
)}
export default Pie